import React, { useEffect, useRef, useState } from "react";
import classes from "./Table.module.css";
import VerticalDotsIcon from "../../icons/VerticalDotsIcon";
import { FiPlus } from "react-icons/fi";

const Table = ({ data, groupClick, dataType, onClick, approve, decline, editItem, userInfo, editUser, deleteUser, suspendUser, columns, clickedIndex = () => {}, setShowDialog, showDialog}) => {
  const [dialogPosition, setDialogPosition] = useState({ top: 0, left: 0 });
  const [selectedRow, setSelectedRow] = useState(null);

  // Ref for the card element to check if click is inside
  const cardRef = useRef(null);
  const iconRef = useRef(null);

  const handleRowClick = (event, row, index) => {
    const { clientX, clientY } = event;

    // Calculate the position of the dialog next to the icon
    setDialogPosition({ top: clientY, left: clientX - 425 });
    setSelectedRow(row);
    setShowDialog(true); // Show the dialog
    clickedIndex(index);
  };

  // Handle clicks outside the floating card
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        cardRef.current &&
        !cardRef.current.contains(event.target) &&
        !iconRef.current.contains(event.target)
      ) {
        setShowDialog(false); // Close the card if click is outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  // Extract headers dynamically from the keys of the first object
  // const headers = Object.keys(data[0]);

  // Function to format header text (camelCase to spaced text)
  const formatHeader = (header) => {
    if (header.includes("ID")) {
      return header; // Keep ID columns as is
    }
    return header
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase());
  };

  // Function to generate action buttons dynamically based on dataType
  const renderActionButtons = () => {
    if (dataType === "User") {
      return (
        <>
          <button className={classes.actionButton} onClick={userInfo}>Info</button>
          <button className={classes.actionButton} onClick={editUser}>Edit</button>
          <button className={classes.actionButton} onClick={suspendUser}>Suspend</button>
          <button className={`${classes.actionButton} ${classes.dangerText}`} onClick={deleteUser}>Delete</button>
        </>
      );
    }
    // Default buttons if dataType is not "user"
    return (
      <>
        {dataType !== "Transactions" && <button className={classes.actionButton} onClick={dataType === "Withdrawals" && approve}>{dataType === "Withdrawals" ? "Approve transaction" : "Send Warning"}</button>}
        {dataType !== "Transactions" && <button className={classes.actionButton} onClick={dataType === "Withdrawals" && decline}>{dataType === "Withdrawals" ? "Decline transaction" : "Restrict Trading"}</button>}
        {(dataType === "Withdrawals" || dataType === "Transactions") && <button className={classes.actionButton} onClick={editItem}>Edit</button>}
      </>
    );
  };


  return (
    <div className={classes.tableDiv}>
      <table style={{ borderCollapse: "collapse", width: "100%", marginBottom: dataType === "Group" && 0  }}>
        <thead>
          <tr>
          {columns.map(col => (
            <th key={col.key}>{col.label}</th>
          ))}
            {dataType !== "Group" && <th></th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col, cellIndex) => {
                let className = "";
                if(dataType === "Manual"){
                    if (col.key === "status") {
                        if (row[col.key] === "Pending") {
                          className = classes.warningText;
                        }
                    }
                }else if(dataType === "Auto" || dataType === "PastRequests"){
                    if (col.key === "status") {
                        if (row[col.key] === "Declined") {
                          className = classes.dangerText;
                        } else if (row[col.key] === "Approved") {
                          className = classes.successText;
                        }
                    }
                }else if (dataType === "Group trading") {
                  if (col.key === "groupID") {
                    className = classes.groupIdText;
                  } else if (col.key === "riskScore") {
                    className =
                    row[col.key] === "Low"
                        ? classes.successText
                        : classes.dangerText;
                  }
                } else if (dataType === "Challenge") {
                  if (row[col.key] === "Failed") {
                    className = classes.dangerText;
                  } else if (row[col.key] === "Ongoing") {
                    className = classes.warningText;
                  } else if (row[col.key] === "Passed") {
                    className = classes.successText;
                  }
                } else if (dataType === "Funded") {
                  if (col.key === "status") {
                    if (row[col.key] === "Failed") {
                      className = classes.dangerText;
                    } else if (row[col.key] === "Restricted") {
                      className = classes.warningText;
                    } else if (row[col.key] === "Active") {
                      className = classes.successText;
                    }
                  } else if (col.key === "groupTrading") {
                    if (row[col.key] === "High") {
                      className = classes.dangerText;
                    } else if (row[col.key] === "Moderate") {
                      className = classes.warningText;
                    } else if (row[col.key] === "No") {
                      className = classes.successText;
                    } else if (row[col.key] === "Low") {
                      className = classes.blueText;
                    }
                  }
                }

                return (
                  <td className={className} key={col.key} onClick={(dataType === "Group trading") ? (col.key === "groupID" ? groupClick : () => {}) : () => {}} role={(dataType === "Group trading") ? (col.key === "groupID" ? "button" : "") : ""}>
                    {row[col.key]}
                  </td>
                );
              })}
              {dataType !== "Group" && <td>
                <div
                  ref={iconRef} // Attach the ref to the icon div
                  className="d-flex align-items-center justify-content-end"
                >
                  {(dataType === "User") && (row.status === "suspended") && <p className={classes.dangerText}>Suspended</p>}
                  {dataType === "Auto" || dataType === "PastRequests" ? (
                    <FiPlus size={20} onClick={() => onClick(rowIndex)} role="button"/>
                  ) : (
                    <VerticalDotsIcon
                      onClick={(event) => handleRowClick(event, row, rowIndex)}
                    />
                  )}
                </div>
              </td>}
            </tr>
          ))}
        </tbody>
      </table>
      {/* Render the AlertDialog positioned near the icon */}
      {showDialog && (
        <div
          ref={cardRef} // Attach the ref to the floating card
          className={`${classes.actionCard} d-flex flex-column gap-2`}
          style={{
            position: "absolute",
            top: dialogPosition.top, // Offset from the clicked position
            left: dialogPosition.left, // Offset from the clicked position
            zIndex: 1000, // Ensure the dialog is on top
          }}
        >
          {/* Add buttons */}
          {renderActionButtons()}
        </div>
      )}
    </div>
  );
};

export default Table;
